import {
    FETCH_DRIVER_PARTNER_PAYOUTS_REQUEST,
    FETCH_DRIVER_PARTNER_PAYOUTS_SUCCESS,
    FETCH_DRIVER_PARTNER_PAYOUTS_FAILURE,
    CREATE_DRIVER_PARTNER_PAYOUT_REQUEST,
    CREATE_DRIVER_PARTNER_PAYOUT_SUCCESS,
    CREATE_DRIVER_PARTNER_PAYOUT_FAILURE,
} from "./types";

import {
    fetchDriverPartnerPayouts,
    createDriverPartnerPayout,
} from "../../services/driverPartnerPayoutService";

export const fetchDriverPartnerPayoutsAction =
    (
        page = 1,
        size = 10
    ) => async (dispatch) => {
        dispatch({
            type:
                FETCH_DRIVER_PARTNER_PAYOUTS_REQUEST,
        });

        const result =
            await fetchDriverPartnerPayouts(
                page,
                size
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    FETCH_DRIVER_PARTNER_PAYOUTS_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    FETCH_DRIVER_PARTNER_PAYOUTS_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };

export const createDriverPartnerPayoutAction =
    (payload) =>
    async (
        dispatch
    ) => {
        dispatch({
            type:
                CREATE_DRIVER_PARTNER_PAYOUT_REQUEST,
        });

        const result =
            await createDriverPartnerPayout(
                payload
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    CREATE_DRIVER_PARTNER_PAYOUT_SUCCESS,
                payload:
                    result.data,
            });

            dispatch(
                fetchDriverPartnerPayoutsAction()
            );
        } else {
            dispatch({
                type:
                    CREATE_DRIVER_PARTNER_PAYOUT_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };